import { render, staticRenderFns } from "./langtest_add.vue?vue&type=template&id=c94d148e&scoped=true&"
import script from "./langtest_add.vue?vue&type=script&lang=js&"
export * from "./langtest_add.vue?vue&type=script&lang=js&"
import style0 from "./langtest_add.vue?vue&type=style&index=0&id=c94d148e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c94d148e",
  null
  
)

export default component.exports